import { UseQueryResult } from '@tanstack/react-query';
import { RegistrarServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

export const useRegistrarServiceRequests = <T = TemplateContract<RegistrarServiceRequest>[]>(
  select?: (data: TemplateContract<RegistrarServiceRequest>[]) => T,
): UseQueryResult<T, string> => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();

  return useQueryWithOptions({
    queryKey: ['queryRegistryRegistrarServiceRequests', operator],
    enabled: !!operator,
    queryFn: async (_, options) => {
      return ledgerApi.queryRegistryRegistrarServiceRequests(options, operator);
    },
    select,
  });
};
